const PageTitle = ({title, className}) => {
    const titleClassName = `my-4 text-2xl font-normal ${className || ''}`;
    return (
        <h1 className={titleClassName}>{title}</h1>
    );
};

export default PageTitle;